import A11yReport from 'umg-ember-backend/components/record-explorer/for/a11y-report';

<template>
  <A11yReport @records={{@model}} @recordType='a11y-report' />
</template>
